import { Center, Stack, Text } from '@mantine/core';
import { useTranslations } from 'next-intl';
import EmptyVoucherIcon from '@/assets/icons/empty-voucher.svg';

const EmptyPromotion = () => {
  const tBooking = useTranslations('booking');
  return (
    <Stack gap={8} align="center" justify="center" pt={56}>
      <Center>
        <EmptyVoucherIcon />
      </Center>
      <Text ta="center" maw={258} fw={500} size="sm" c="neutral.5">
        {tBooking('promo.empty_promo_code')}
      </Text>
    </Stack>
  );
};
export default EmptyPromotion;
